import {
  HOME_BUILD_FIELDS,
  INSURANCE_QUESTIONS_BY_TYPE,
  INSURANCE_TYPES_ICONS_V2,
  MOTORCYCLE_INFO_FIELDS,
  VEHICLE_INFO_FIELDS,
} from './insurance';
import { POLICY_SCAN_STATUS } from '../types';
import { titleOptions } from './options';
import {
  ACCIDENT_QUESTION,
  GENDER_QUESTION,
  STAR_INSURANCE_CLAIM_QUESTIONS,
  STAR_RV_LICENSE_CONFIRM,
} from './typeform-questions';
import {
  ADDRESS_QUESTION,
  ANNUAL_DISTANCE_QUESTION,
  AREA_OF_GARAGING_QUESTION,
  CC_RATING_QUESTION,
  CURRENT_INSURER_QUESTION,
  EXCESS_QUESTION,
  FINANCE_COMPANY_QUESTION,
  INSURED_AMOUNT_QUESTION,
  LICENSE_CLASS_QUESTION,
  LICENSE_COUNTRY_QUESTION,
  LICENSE_NUMBER_QUESTION,
  LICENSE_VERSION_QUESTION,
  LICENSE_YEARS_QUESTION,
  MAKE_QUESTION,
  MODEL_QUESTION,
  MOD_DESCRIPTION_QUESTION,
  MOD_VALUE_QUESTION,
  MOTORCYCLE_COVER_TYPE_QUESTION,
  MOTORCYCLE_LICENSE_CLASS_QUESTION,
  MOTORCYCLE_OWNERSHIP_QUESTION,
  MOTORCYCLE_PARKING,
  MOTORCYCLE_REGO_QUESTION,
  MOTORCYCLE_USE_QUESTION,
  OTHER_PARTY_FINANCE_QUESTION,
  PERCENTAGE_USE_QUESTION,
  PHONE_QUESTION,
  POLICY_START_DATE_QUESTION,
  PURCHASE_COVER_TYPE_QUESTION,
  REGO_STATUS_QUESTION,
  STAR_HAS_FINANCE_QUESTION,
  STAR_RV_LICENSE_CLASS_QUESTION,
  STAR_RV_LICENSE_YEARS_QUESTION,
  STAR_RV_PARKING_QUESTION,
  STAR_RV_USE_QUESTION,
  SUBMODEL_QUESTION,
  THEFT_INCIDENTS_12MONTHS_MOTORCYCLE_QUESTION,
  THEFT_INCIDENTS_12MONTHS_QUESTION,
  THEFT_INCIDENTS_5YEARS_MOTORCYCLE_QUESTION,
  THEFT_INCIDENTS_5YEARS_QUESTION,
  VEHICLE_PARKING_QUESTION,
  VEHICLE_USE_QUESTION,
  VEHICLE_YEAR_QUESTION,
  VIN_QUESTION,
  STAR_FINANCE_COMPANY_QUESTION,
} from './questions';
import { ProviderImagesUrlSmall, ProviderImagesUrlTiny } from './images';
import { INSURANCE_TYPES_NAMES } from './insurance-types-names';

export const COVE_PET_URL = 'https://www.coveinsurance.co.nz/lp/quashed-pet/';

export const Q4E_CASHBACK_AMOUNT = { text: '6 months', monthsOff: 6 };

export const MARKET_SCAN_FIELDS_TO_IGNORE = ['paymentMethod', 'policyNumber'];

export const LIFE_MARKET_SCAN_WAITING_TIME = 30000;

export const MARKET_SCAN_STATUS_OPTIONS = [
  {
    key: POLICY_SCAN_STATUS.READY,
    value: POLICY_SCAN_STATUS.READY,
    text: POLICY_SCAN_STATUS.READY,
  },
  {
    key: POLICY_SCAN_STATUS.PENDING,
    value: POLICY_SCAN_STATUS.PENDING,
    text: POLICY_SCAN_STATUS.PENDING,
  },
  {
    key: POLICY_SCAN_STATUS.VIEWED,
    value: POLICY_SCAN_STATUS.VIEWED,
    text: POLICY_SCAN_STATUS.VIEWED,
  },
  {
    key: POLICY_SCAN_STATUS.ABANDONED,
    value: POLICY_SCAN_STATUS.ABANDONED,
    text: POLICY_SCAN_STATUS.ABANDONED,
  },
  {
    key: POLICY_SCAN_STATUS.IN_REVIEW,
    value: POLICY_SCAN_STATUS.IN_REVIEW,
    text: POLICY_SCAN_STATUS.IN_REVIEW,
  },
];

export const QUASHED_SUPPORTED_VEHICLE_PROVIDERS = [
  'Cove',
  'Protecta',
  'Autosure',
  'Provident',
  'AMP',
] as const;

export const QUICK_BUY_VEHICLE_PROVIDERS = [
  'Protecta',
  'Provident',
] as const;

export const MARKET_SCAN_QUESTIONS_BY_NAME = {
  ...INSURANCE_QUESTIONS_BY_TYPE,
  [INSURANCE_TYPES_NAMES.VEHICLE]: [
    ...INSURANCE_QUESTIONS_BY_TYPE[INSURANCE_TYPES_NAMES.VEHICLE],
    ...VEHICLE_INFO_FIELDS,
    ADDRESS_QUESTION,
  ],
  [INSURANCE_TYPES_NAMES.MOTORCYCLE]: [
    ...INSURANCE_QUESTIONS_BY_TYPE[INSURANCE_TYPES_NAMES.MOTORCYCLE],
    ...MOTORCYCLE_INFO_FIELDS,
    ADDRESS_QUESTION,
  ],
  [INSURANCE_TYPES_NAMES.HOME]: [
    ...INSURANCE_QUESTIONS_BY_TYPE[INSURANCE_TYPES_NAMES.HOME],
    ...HOME_BUILD_FIELDS,
  ],
};

export const MARKET_SCAN_POLICIES = [
  INSURANCE_TYPES_NAMES.VEHICLE,
  INSURANCE_TYPES_NAMES.CONTENT,
  INSURANCE_TYPES_NAMES.HOME,
  INSURANCE_TYPES_NAMES.MOTORCYCLE,
  INSURANCE_TYPES_NAMES.HOME_CONTENTS,
  INSURANCE_TYPES_NAMES.LANDLORD,
];

export const LIFE_REFERRAL_ITEMS = [
  {
    title: INSURANCE_TYPES_NAMES.LIFE,
    key: INSURANCE_TYPES_NAMES.LIFE,
    icon: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.LIFE],
    tag: 'Adviser',
  },
  {
    title: INSURANCE_TYPES_NAMES.HEALTH,
    key: INSURANCE_TYPES_NAMES.HEALTH,
    icon: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.HEALTH],
    tag: 'Adviser',
  },
  {
    title: INSURANCE_TYPES_NAMES.CANCER,
    key: INSURANCE_TYPES_NAMES.CANCER,
    icon: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.CANCER],
    tag: 'Adviser',
  },
  {
    title: INSURANCE_TYPES_NAMES.INCOME,
    key: INSURANCE_TYPES_NAMES.INCOME,
    icon: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.INCOME],
    tag: 'Adviser',
  },
  {
    title: INSURANCE_TYPES_NAMES.MORTGAGE,
    key: INSURANCE_TYPES_NAMES.MORTGAGE,
    icon: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.MORTGAGE],
    tag: 'Adviser',
  },
  {
    title: INSURANCE_TYPES_NAMES.REDUNDANCY,
    key: INSURANCE_TYPES_NAMES.REDUNDANCY,
    icon: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.REDUNDANCY],
    tag: 'Adviser',
  },
  {
    title: INSURANCE_TYPES_NAMES.TRAUMA,
    key: INSURANCE_TYPES_NAMES.TRAUMA,
    icon: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.TRAUMA],
    tag: 'Adviser',
  },

  {
    title: INSURANCE_TYPES_NAMES.DISABILITY,
    key: INSURANCE_TYPES_NAMES.DISABILITY,
    icon: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.DISABILITY],
    tag: 'Adviser',
  },
];

export const MARKET_SCAN_AVERAGE_SAVINGS = {
  [INSURANCE_TYPES_NAMES.VEHICLE]: '$362',
  [INSURANCE_TYPES_NAMES.CONTENT]: '$301',
  [INSURANCE_TYPES_NAMES.HOME]: '$653',
  [INSURANCE_TYPES_NAMES.MOTORCYCLE]: '$240',
  [INSURANCE_TYPES_NAMES.HOME_CONTENTS]: '$855',
  [INSURANCE_TYPES_NAMES.LANDLORD]: '$410',
  [INSURANCE_TYPES_NAMES.LIFE]: '$120',
};

export const MARKET_SCAN_POLICIES_WIKI = [
  ...MARKET_SCAN_POLICIES,
  INSURANCE_TYPES_NAMES.LIFE,
  INSURANCE_TYPES_NAMES.PET,

  // Previously goes to premium for now we go to normal MS
  INSURANCE_TYPES_NAMES.HOME_CONTENTS,
  INSURANCE_TYPES_NAMES.BOAT,
  INSURANCE_TYPES_NAMES.RENTERS,
  INSURANCE_TYPES_NAMES.TRAVEL,
  INSURANCE_TYPES_NAMES.LANDLORD,
];

export const MARKET_SCAN_POLICIES_BROKER_FIRST = [
  INSURANCE_TYPES_NAMES.HOME,
  INSURANCE_TYPES_NAMES.CONTENT,
  INSURANCE_TYPES_NAMES.VEHICLE,
  INSURANCE_TYPES_NAMES.LANDLORD,
];

export const MARKET_SCAN_POLICIES_SOON = [INSURANCE_TYPES_NAMES.PET];


export const MARKET_SCAN_VEHICLE_LOGOS = [
  ProviderImagesUrlSmall.AA,
  ProviderImagesUrlSmall.AMP,
  ProviderImagesUrlSmall.AUTOSURE,
  ProviderImagesUrlSmall.COVE,
  ProviderImagesUrlSmall.TOWER,
  ProviderImagesUrlSmall.PROTECTA,
  ProviderImagesUrlSmall.TRADE_ME,
  ProviderImagesUrlSmall.PROVIDENT,
  ProviderImagesUrlSmall.MAS,
];

export const MARKET_SCAN_HOME_AND_CONTENTS_LOGOS = [
  ProviderImagesUrlSmall.AA,
  ProviderImagesUrlSmall.AMP,
  ProviderImagesUrlSmall.INITIO,
  ProviderImagesUrlSmall.TRADE_ME,
  ProviderImagesUrlSmall.TOWER,
  ProviderImagesUrlSmall.MAS,

];

export const MARKET_SCAN_LIFE_LOGOS = [
  ProviderImagesUrlTiny.AIA,
  ProviderImagesUrlTiny.PINNACLE,
  ProviderImagesUrlTiny.PARTNERS_LIFE,
];

const TITLE_QUESTION = {
  line: 1,
  before: 'Title',
  key: 'title',
  order: 1,
  type: 'dropdown',
  options: titleOptions,
};

const PROTECTA_PHONE_QUESTION = {
  ...PHONE_QUESTION,
  tooltipBefore:
    'This is a required field from Assurant, Quashed will not call you.',
};

const DRIVER_QUESTIONS_MAIN_DRIVER = [
  PROTECTA_PHONE_QUESTION,
  LICENSE_CLASS_QUESTION,
  LICENSE_YEARS_QUESTION,
  LICENSE_COUNTRY_QUESTION,
  R.merge(THEFT_INCIDENTS_5YEARS_QUESTION, {
    line: 7,
    before: 'Number of theft/at-fault incidents (last 5 years)',
  }),
  R.merge(THEFT_INCIDENTS_12MONTHS_QUESTION, {
    line: 8,
    before: 'Number of theft/at-fault incidents (last 12 months)',
  }),
  CURRENT_INSURER_QUESTION,
];

const DRIVER_QUESTIONS = [
  PERCENTAGE_USE_QUESTION,
  PROTECTA_PHONE_QUESTION,
  LICENSE_CLASS_QUESTION,
  LICENSE_YEARS_QUESTION,
  LICENSE_COUNTRY_QUESTION,
  R.merge(THEFT_INCIDENTS_5YEARS_QUESTION, {
    line: 7,
    before: 'Number of theft/at-fault incidents (last 5 years)',
  }),
  R.merge(THEFT_INCIDENTS_12MONTHS_QUESTION, {
    line: 8,
    before: 'Number of theft/at-fault incidents (last 12 months)',
  }),
  CURRENT_INSURER_QUESTION,
];

const RIDER_QUESTIONS_MAIN_DRIVER = [
  PROTECTA_PHONE_QUESTION,
  MOTORCYCLE_LICENSE_CLASS_QUESTION,
  MOTORCYCLE_OWNERSHIP_QUESTION,
  R.merge(LICENSE_COUNTRY_QUESTION, {
    before: 'Rider licence country',
  }),
  LICENSE_NUMBER_QUESTION,
  LICENSE_VERSION_QUESTION,
  R.merge(THEFT_INCIDENTS_5YEARS_MOTORCYCLE_QUESTION, {
    line: 9,
    before: 'Number of theft/at-fault incidents (last 5 years)',
  }),
  R.merge(THEFT_INCIDENTS_12MONTHS_MOTORCYCLE_QUESTION, {
    line: 10,
    before: 'Number of theft/at-fault incidents (last 12 months)',
  }),
  R.merge(CURRENT_INSURER_QUESTION, { line: 11 }),
];

const RIDER_QUESTIONS = [
  PERCENTAGE_USE_QUESTION,
  PROTECTA_PHONE_QUESTION,
  MOTORCYCLE_LICENSE_CLASS_QUESTION,
  MOTORCYCLE_OWNERSHIP_QUESTION,
  R.merge(LICENSE_COUNTRY_QUESTION, {
    before: 'Rider licence country',
  }),
  LICENSE_NUMBER_QUESTION,
  LICENSE_VERSION_QUESTION,
  R.merge(THEFT_INCIDENTS_5YEARS_MOTORCYCLE_QUESTION, {
    line: 9,
    before: 'Number of theft/at-fault incidents (last 5 years)',
  }),
  R.merge(THEFT_INCIDENTS_12MONTHS_MOTORCYCLE_QUESTION, {
    line: 10,
    before: 'Number of theft/at-fault incidents (last 12 months)',
  }),
  R.merge(CURRENT_INSURER_QUESTION, { line: 11 }),
];

export const MARKET_SCAN_PURCHASE_QUESTIONS = {
  [INSURANCE_TYPES_NAMES.VEHICLE]: {
    // Vehicle questions
    0: [
      POLICY_START_DATE_QUESTION,
      PURCHASE_COVER_TYPE_QUESTION,
      R.mergeLeft(
        {
          placeholder: '',
          key: 'sumInsured',
          fieldKey: 'sumInsured',
          showKeyValue: ({ coverType }) => coverType !== '3rd party',
        },
        INSURED_AMOUNT_QUESTION,
      ),
      {
        ...EXCESS_QUESTION,
        key: 'voluntaryExcess',
        fieldKey: 'voluntaryExcess',
        creatable: false,
        inputType: undefined,
        showKeyValue: ({ coverType }) => coverType === 'full',
      },
      VEHICLE_PARKING_QUESTION,
      AREA_OF_GARAGING_QUESTION,
      ANNUAL_DISTANCE_QUESTION,
      OTHER_PARTY_FINANCE_QUESTION,
      FINANCE_COMPANY_QUESTION,
      R.assoc('before', 'Make of vehicle', MAKE_QUESTION),
      R.assoc('before', 'Model of vehicle', MODEL_QUESTION),
      R.assoc('before', 'Sub model of vehicle', SUBMODEL_QUESTION),
      MOD_VALUE_QUESTION,
      MOD_DESCRIPTION_QUESTION,
      {
        ...VEHICLE_USE_QUESTION,
        warning: {
          value: 'business',
          text: 'Business use means the vehicle will be used for Business or Trade purposes. This policy will not cover (under any use) vehicles carrying fare paying passengers E.G. Taxi or Uber, vehicles used for courier or delivery purposes, vehicles designed or altered solely to carry goods or merchandise, or vehicles with a Gross Vehicle Weight of 3500kg or more. If in doubt about which use to select, please call Assurant at 0800 776 832 to discuss your needs.',
        },
      },
    ],
    // Driver questions
    1: [
      TITLE_QUESTION,
      {
        line: 2,
        before: 'First name',
        key: 'firstName',
        order: 1,
      },
      {
        line: 3,
        before: 'Last name',
        key: 'lastName',
        order: 1,
      },
      {
        line: 4,
        before: 'Date of Birth',
        key: 'dateOfBirth',
        order: 1,
        type: 'birthday',
      },
      {
        ...GENDER_QUESTION,
        before: 'Gender',
        line: 5,
        order: 1,
        after: '',
      },
      ...DRIVER_QUESTIONS.map((q) => R.assoc('line', q.line + 5, q)),
    ],
  },
  [INSURANCE_TYPES_NAMES.MOTORCYCLE]: {
    // Vehicle questions
    0: [
      POLICY_START_DATE_QUESTION,
      MOTORCYCLE_COVER_TYPE_QUESTION,
      AREA_OF_GARAGING_QUESTION,
      MOTORCYCLE_PARKING,
      MAKE_QUESTION,
      MODEL_QUESTION,
      CC_RATING_QUESTION,
      VEHICLE_YEAR_QUESTION,
      REGO_STATUS_QUESTION,
      R.merge(MOTORCYCLE_REGO_QUESTION, {
        placeholder: 'e.g. A1ABC',
        line: 9,
      }),
      VIN_QUESTION,
      OTHER_PARTY_FINANCE_QUESTION,
      FINANCE_COMPANY_QUESTION,
      MOD_VALUE_QUESTION,
      MOD_DESCRIPTION_QUESTION,
      {
        ...MOTORCYCLE_USE_QUESTION,
        warning: {
          value: 'Business use',
          text: 'Business use means the vehicle will be used for Business or Trade purposes. This policy will not cover (under any use) motorcycles let out on hire, motorcycles used for carrying fare paying passengers, or motorcycles used for delivery or courier purposes. If you unsure what use to select, please call Assurant at 0800 776 832 to discuss your needs.',
        },
      },
    ],
    // Driver questions
    1: [
      TITLE_QUESTION,
      {
        line: 2,
        before: 'First name',
        key: 'firstName',
        order: 1,
      },
      {
        line: 3,
        before: 'Last name',
        key: 'lastName',
        order: 2,
      },
      {
        line: 4,
        before: 'Date of Birth',
        key: 'dateOfBirth',
        order: 1,
        type: 'birthday',
      },
      {
        ...GENDER_QUESTION,
        before: 'Gender',
        line: 5,
        order: 2,
        after: '',
      },
      ...RIDER_QUESTIONS.map((q) => R.assoc('line', q.line + 5, q)),
    ],
  },
};

export const STAR_MARKET_SCAN_PURCHASE_QUESTIONS = {
  [INSURANCE_TYPES_NAMES.RV]: {
    0: [
      POLICY_START_DATE_QUESTION,
      {
        ...INSURED_AMOUNT_QUESTION,
        key: 'insuredAmount',
        fieldKey: 'insuredAmount',
        placeholder: 'Insured amount (modifications included)',
        label: 'Insured amount (modifications included)',
        before: 'Insured amount (modifications included)',
      },
      STAR_RV_PARKING_QUESTION,
      STAR_HAS_FINANCE_QUESTION,
      STAR_FINANCE_COMPANY_QUESTION,
      VEHICLE_YEAR_QUESTION,
      R.assoc('before', 'Make of vehicle', MAKE_QUESTION),
      R.assoc('before', 'Model of vehicle', MODEL_QUESTION),
      STAR_RV_USE_QUESTION,
      CURRENT_INSURER_QUESTION,
    ],
    // Driver questions
    1: [
      {
        line: 1,
        before: 'First name',
        key: 'firstName',
        order: 1,
      },
      {
        line: 2,
        before: 'Last name',
        key: 'lastName',
        order: 1,
      },
      {
        line: 3,
        before: 'Date of Birth',
        key: 'dateOfBirth',
        order: 1,
        type: 'birthday',
      },
      R.merge(PHONE_QUESTION, {
        line: 4,
      }),
      R.merge(STAR_RV_LICENSE_CLASS_QUESTION, {
        line: 5,
      }),
      R.merge(STAR_RV_LICENSE_CONFIRM, {
        line: 6,
      }),
      R.merge(STAR_RV_LICENSE_YEARS_QUESTION, {
        line: 7,
      }),
      R.merge(ACCIDENT_QUESTION, {
        line: 8,
      }),
      ...STAR_INSURANCE_CLAIM_QUESTIONS.map((q) =>
        R.assoc('line', q.line + 3, q),
      ),
    ],
  },
};

export const PROTECTA_BENEFITS = {
  excludeUnder25s: {
    savings: true,
    label: 'Exclude drivers younger than 25 years old',
    tooltip:
      "This policy includes a discount for excluding all under 25 year olds that haven't been disclosed to us on this policy. This means any undisclosed driver under 25 years old will not be covered under this policy. Tick this box if you would like to add this discount and extend the policy to cover undisclosed drivers under the age of 25.",
  },
  namedDriver: {
    savings: true,
    label: 'Exclude other (undisclosed) drivers',
    tooltip:
      'This policy includes a discount as a result of all undisclosed drivers being subject to an additional $250 excess. Tick this box if you would like to add this discount and extend the policy to allow undisclosed drivers at the standard policy excess.',
  },
  rentalCars: {
    label: 'Rental cars',
    type: 'dropdown',
    tooltip:
      'If your vehicle is unable to be driven, or it is being repaired for a claim that is payable, the costs of renting a similar vehicle will covered for up to the amount you select.',
  },
  roadsideAssistance: {
    label: 'Roadside assistance',
    tooltip:
      '24/7 assistance for Flat Tyre, Damaged Wheel, Flat Battery, Locked Out, Lost Keys, Out of Fuel, Breakdown Towing.',
  },
  voluntaryExcess: {
    savings: true,
    label: 'Voluntary excess (added to your standard excess)',
    type: 'dropdown',
    tooltip:
      'An additional excess to pay on top of your standard excess on all claims in exchange for a cheaper premium.',
  },
  windscreens: {
    label: 'Windscreen cover',
    tooltip:
      'Cover for damage to any window glass (including sunroofs), with no excess to pay.',
  },
  ncbProtection: {
    label: 'No claims bonus protection',
    tooltip:
      'If you select this option, you can make one at-fault claim in each policy year without penalty. Any additional at-fault claims during the period will affect your NCB when the policy renews.',
  },
};

export enum LifeProviders {
  AIA = 'AIA',
  PARTNERS_LIFE = 'Partners Life',
  PINNACLE_LIFE = 'Pinnacle Life',
}

export enum AIAProducts {
  STARTER_LIFE = 'VSL21',
  STARTER_LIFE_PLUS = 'VSLP21',
  HEALTHY_STARTER = 'VSR21',
}

export enum AIABenefitCodes {
  RENT = 'Rent',
  MORTGAGE = 'Mortgage',
}

export enum PinnacleProducts {
  LIFE = 'Life',
  CI_RIDER = 'CiRider',
  TPD_RIDER = 'TpdRider',
}

export const EXCESS_TOOLTIPS = {
  [INSURANCE_TYPES_NAMES.VEHICLE]:
    '$500 excess is the most popular option for vehicle from our existing customers',
  [INSURANCE_TYPES_NAMES.HOME]:
    '$1000 excess is the most popular option for house from our existing customers',
  [INSURANCE_TYPES_NAMES.CONTENT]:
    '$250 excess is the most popular option for contents from our existing customers',
  [INSURANCE_TYPES_NAMES.MOTORCYCLE]:
    '$500 excess is the most popular option for motorcycle from our existing customers',
};

export const QUASHED_SUPPORTED_TOOLTIP =
  'We can assist you and provide support with this insurance provider. If you purchase the policy through us, we can help support your questions or query about a potential claim based on the policy.';

export const QUICK_BUY_TOOLTIP =
  'Purchase the policy quickly and directly on Quashed, without having to rekey your information on the insurance provider website. You do not pay more for this service. It will be the same price as going directly to their website. After payment is made, your policy is instantly loaded on to your Quashed dashboard. A copy of the policy documents will also be sent to you directly via email.';

export const LIFE_MS_FORM_KEYS = [
  'gender',
  'dateOfBirth',
  'smoker',
  'isNZResident',
  'income',
  'employment',
  'workDescription',
];

export const PARTNERS_LIFE_URL =
  'https://advice.partnerslife.co.nz/referral-portal?source=quashed';

export const PINNACLE_LIFE_ADVICE_URL =
  'https://advice.pinnaclelife.co.nz?utm_source=quashed';

export const PINNACLE_LIFE_CALLBACK_URL =
  'https://www.pinnaclelife.co.nz/?request-callback=1&utm_source=quashed';

export const LifeProviderDescription: Record<
  string,
  { logoUrl: string; description: string }
> = {
  [LifeProviders.AIA]: {
    logoUrl: ProviderImagesUrlTiny.AIA,
    description:
      'As a company with 100 years of history, our vision is to help make New Zealand one of the healthiest and best protected nations in the world.',
  },
  [LifeProviders.PINNACLE_LIFE]: {
    logoUrl: ProviderImagesUrlTiny.PINNACLE,
    description:
      'Helping New Zealanders get their Life Cover sorted for over 20 years.',
  },
  [LifeProviders.PARTNERS_LIFE]: {
    logoUrl: ProviderImagesUrlTiny.PARTNERS_LIFE,
    description:
      "Partners Life launched back in 2011, and since then we've paid more than $1.25 Billion in claims.",
  },
};
